// extracted by mini-css-extract-plugin
module.exports = {"container":"Dataform_container__3yDz3","FormContainer":"Dataform_FormContainer__1r8Fl","Label":"Dataform_Label__1DHNG","SelectContainer":"Dataform_SelectContainer__1Sy7g"};